import { useEffect } from "react";

const CacheInvalidator = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/build-meta.json", { cache: "no-store" });
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new TypeError("Response was not JSON");
        }
        const data = await res.json();
        const latestVersion = data.version;
        const currentVersion = localStorage.getItem("build-version");

        if (currentVersion && latestVersion != currentVersion) {
          console.log("🔄 New version detected. Reloading...");
          localStorage.setItem("build-version", latestVersion);
          window.location.reload(true);
        } else if (!currentVersion) {
          localStorage.setItem("build-version", latestVersion);
        }
      } catch (err) {
        console.error("Failed to check app version", err);
        // Set a default version if the check fails
        if (!localStorage.getItem("build-version")) {
          localStorage.setItem("build-version", "1.0.0");
        }
      }
    };

    checkVersion();
  }, []);

  return null;
};

export default CacheInvalidator;
